/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, memo, useState, useRef } from "react";
import InfoPromotion from "./Components/InfoPromotion";
import LevelPromotion from "./Components/LevelPromotion";
import ConfirmOrder from "components/ConfirmOrder";
import useStyles from "./styles";
import NoneData from "components/NoneData";
import Line from "./Components/Line";
import Product from "components/Product";

import {
	getCampaignDetailAction,
	setCampaignDetailAction
} from "store/actions/SpecialOfferPageAction";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { setCartAction } from "store/actions/OrderPageAction";
import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";

let changeListProduct = [];

const PromotionDetailPage = memo(props => {
	const history = useHistory();
	const classes = useStyles();
	const {
		campaignDetail,
		carts,
		infoShop,
		dispatchSetCart,
		dispatchGetCampaignDetail,
		dispatchSetCampaignDetail
	} = props;

	const [listDataProduct, setListDataProduct] = useState([]);
	const business = infoShop?.business || "THOPHAT";
	const refElementPromotionDetail = useRef(null);
	const elementPromotionDetail = document.getElementById(
		"elementPromotionDetail"
	);
	const distanceToTop = elementPromotionDetail?.offsetTop;
	const rewardGifts = campaignDetail?.promotionDetails?.rewardGifts;
	const rewardDiscounts = campaignDetail?.promotionDetails?.rewardDiscounts;
	const idNotification = new URLSearchParams(history.location.search).get(
		"id"
	);

	useEffect(() => {
		return () => {
			dispatchSetCampaignDetail({});
		};
	}, []);

	useEffect(() => {
		if (idNotification) {
			const promotionDetail = {
				business: business,
				campaignId: idNotification
			};
			dispatchGetCampaignDetail(promotionDetail);
		} else {
			history.push("/home");
		}
	}, [idNotification]);

	useEffect(() => {
		if (!carts) {
			return;
		}
		changeListProduct = carts;
	}, [carts]);

	const handleConfirmOrder = () => {
		dispatchSetCart(changeListProduct);
		history.push("/carts");
	};

	const configDataProduct = data => {
		return data.map(item => {
			let index = carts.findIndex(order => order.id === item.id);
			if (index > -1) {
				return { ...item, isSelected: true };
			} else {
				return { ...item, isSelected: false };
			}
		});
	};

	useEffect(() => {
		if (!campaignDetail?.productRequireds) {
			return;
		}
		const dataListBestSale = configDataProduct(
			campaignDetail?.productRequireds
		);
		setListDataProduct(dataListBestSale);
	}, [campaignDetail?.productRequireds]);

	const updateChangeListProduct = item => {
		if (changeListProduct?.find(product => product.id === item.id)) {
			const dataFilter = changeListProduct.filter(
				el => el.id !== item.id
			);
			changeListProduct = dataFilter;
		} else {
			changeListProduct = [...changeListProduct, item];
		}
		dispatchSetCart(changeListProduct);
	};

	const getChangeListProduct = () => {
		return changeListProduct;
	};

	return !isEmpty(campaignDetail) ? (
		<Grid
			ref={refElementPromotionDetail}
			id="elementPromotionDetail"
			style={{
				height: `calc(100vh - ${distanceToTop}px)`,
				overflow: "auto"
			}}
		>
			<Grid classes={{ root: classes.root }}>
				<Grid style={{ padding: "0px 16px" }}>
					<InfoPromotion campaignDetail={campaignDetail} />
					{rewardGifts?.conditionRewards?.length > 0 &&
						rewardGifts?.conditionRewards?.map(
							(rewardGift, index) => (
								<LevelPromotion
									products={rewardGift}
									key={index}
									isAllProduct={rewardGifts?.isAllProduct}
									type="GIFT"
								/>
							)
						)}

					{rewardDiscounts?.conditionRewards?.length > 0 && (
						<React.Fragment>
							{rewardGifts?.conditionRewards?.length > 0 && (
								<Line />
							)}
							{rewardDiscounts?.conditionRewards?.map(
								(rewardDiscount, index) => (
									<LevelPromotion
										products={rewardDiscount}
										key={index}
										isAllProduct={
											rewardDiscounts?.isAllProduct
										}
										type="DISCOUNT"
									/>
								)
							)}
						</React.Fragment>
					)}
				</Grid>
				{listDataProduct?.length > 0 && (
					<React.Fragment>
						<Grid classes={{ root: classes.title }}>
							Sản phẩm áp dụng
						</Grid>
						<Product
							listData={listDataProduct}
							updateChangeListProduct={updateChangeListProduct}
							isConditionPromotion={true}
						/>
					</React.Fragment>
				)}
				{carts?.length > 0 && <div style={{ height: 60 }} />}
			</Grid>
			{carts?.length > 0 && (
				<ConfirmOrder
					bottom={0}
					handleConfirmOrder={handleConfirmOrder}
					listProduct={carts}
					getChangeListProduct={getChangeListProduct}
				/>
			)}
		</Grid>
	) : (
		<Grid classes={{ root: classes.centerPage }}>
			<NoneData />
		</Grid>
	);
});

const mapStateToProps = state => {
	return {
		campaignDetail: state.specialOfferPageReducer.campaignDetail,
		infoShop: state.homePageReducer.infoShop,
		carts: state.orderPageReducer.carts
	};
};

const mapDispatchToProps = dispatch => {
	return {
		dispatchGetCampaignDetail: params => {
			dispatch(getCampaignDetailAction(params));
		},
		dispatchSetCampaignDetail: params => {
			dispatch(setCampaignDetailAction(params));
		},
		dispatchSetCart: params => {
			dispatch(setCartAction(params));
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PromotionDetailPage);
